import { assertRange } from "./Debug";
/**
 * Assert that the number is in the given range.
 */
export function range(min) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
  var valueMap = new WeakMap();
  return function (target, propertyKey) {
    Reflect.defineProperty(target, propertyKey, {
      configurable: true,
      enumerable: true,
      get: function get() {
        return valueMap.get(this);
      },
      set: function set(newValue) {
        assertRange(newValue, min, max);
        valueMap.set(this, newValue);
      }
    });
  };
}
/**
 * Convert the time to seconds and assert that the time is in between the two
 * values when being set.
 */
export function timeRange(min) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
  var valueMap = new WeakMap();
  return function (target, propertyKey) {
    Reflect.defineProperty(target, propertyKey, {
      configurable: true,
      enumerable: true,
      get: function get() {
        return valueMap.get(this);
      },
      set: function set(newValue) {
        assertRange(this.toSeconds(newValue), min, max);
        valueMap.set(this, newValue);
      }
    });
  };
}